import PropTypes from 'prop-types'
import { Box, Select, MenuItem } from '@mui/material'
import useStyles from './styles'

const TextWithDropdown = ({ options, defaultOption, onChange }) => {
  const styles = useStyles()
  return (
    <Box sx={styles.container}>
      <Select
        onChange={onChange}
        defaultValue={defaultOption}
        className={styles.dropdown}
        MenuProps={{
          PaperProps: {
            className: styles.dropdownMenu,
          },
        }}
        displayEmpty
        inputProps={{
          'aria-label': 'Without label',
          className: styles.hiddenSelect,
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            value={option.value}
            disabled={option.disabled}
            style={
              option.value === defaultOption && null === defaultOption
                ? { display: 'none' }
                : null
            }
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}

TextWithDropdown.propTypes = {
  text: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ).isRequired,
  defaultOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
}

export default TextWithDropdown
